import React from 'react';
import { SectionHeading } from '../ui/SectionHeading';
import { ButtonLink } from '../ui/ButtonLink';
import { deliverySteps } from '../../data/quality';
export function QualityOverview() {
  return <section aria-labelledby="quality-title" className="bg-charcoal py-20 md:py-28" data-id="element-201" data-mp="35sbs7akey3cr">
      <div className="mx-auto max-w-site px-5 md:px-8" data-id="element-202" data-mp="30sh1p84jvfs8">
        <div className="flex flex-col gap-8 md:flex-row md:items-end md:justify-between" data-id="element-203" data-mp="30ts87fpdr1n1">
          <SectionHeading id="quality-title" label="Quality & project management" title="Controlled from plan to handover" intro="Quality is delivered through teamwork and peer-to-peer review, with clearly defined site roles and documented control procedures." className="max-w-2xl" data-id="element-204" data-mp="2d3o1v0kt4nsc" />
          <ButtonLink to="/about/quality-project-management" variant="outline" showArrow className="self-start md:self-auto" data-id="element-205" data-mp="1ucdbckizud0z">
            Our Approach
          </ButtonLink>
        </div>

        <ol className="mt-14 grid gap-10 md:grid-cols-2 lg:grid-cols-4 lg:gap-8" data-id="element-206" data-mp="hhinm8tymoo6">
          {deliverySteps.map((step, index) => <li key={step.title} className="relative border-t-2 border-white/15 pt-6" data-id="element-207" data-mp="mfbwxaqk7yso" data-mpi={index}>
              <span className="absolute -top-[2px] left-0 h-[2px] w-16 bg-brand-red" aria-hidden="true" data-id="element-208" data-mp="r6tyo10eq3ep" />
              <span className="font-display text-[15px] font-bold uppercase tracking-[0.16em] text-brand-light" data-id="element-209" data-mp="v7m6qqxjm29e">
                Stage {index + 1}
              </span>
              <h3 className="mt-2 font-display text-[26px] font-bold uppercase leading-none text-white" data-id="element-210" data-mp="3h7vz3ktt61y">{step.title}</h3>
              <p className="mt-3 text-[15px] leading-relaxed text-steel-300" data-id="element-211" data-mp="7itfv8vs2kln">{step.text}</p>
            </li>)}
        </ol>
      </div>
    </section>;
}